// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Notifications_wrapper__32gpA","emptyState":"Notifications_emptyState__3p705"};